module.exports = __webpack_public_path__ + "static/img/haos-game-lucre-games-gameplay-3.6165ef9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/haos/haos-game-lucre-games-gameplay-3.gif
// module id = 0Ent
// module chunks = 0